import { Column } from '~components/table-view';
import CutoverSahServiceCell from '~support-at-home/components/config/service-cutover/CutoverSahServiceCell';

/**
 * Step 2 of the service cutover assistant - the local service types associated with the services
 * being cut over.
 *
 * Headed to match the Service Type Assocs. screen, because these are the same two things: the
 * government service on one side, the local service types associated with it on the other. Calling
 * them anything else here would invent a second vocabulary for one relationship.
 *
 * The SAH Service column exists because a run can cover several services at once and the same local
 * service type can hang off more than one of them. Without it two rows would be identical on screen
 * and there would be no way to tell which service each was carrying. It carries the same info icon
 * the associations screen does, for the same reason - the name alone does not identify the
 * government service, and two periods of one service differ only in detail shown there.
 *
 * The status column is the whole point of showing rows that are already done: a provider picking up
 * an interrupted run has to be able to tell what the earlier run got through, and a row that simply
 * disappeared would tell them nothing.
 */
const SERVICE_WIDTH = '300px';
const STATUS_WIDTH = '170px';

const columns: Column[] = [
  {
    id: 'service_name',
    header: 'SAH Service',
    caption: 'The Support at Home service published by Services Australia that is being cut over',
    type: 'text',
    style: { width: SERVICE_WIDTH },
    classNames: { column: 'sah-cutover-wrap-cell' },
    renderReadOnly: (_value, row) => CutoverSahServiceCell({ row }),
  },
  {
    id: 'name',
    header: 'Associated Service',
    caption: 'The TurnPoint service type mapped to this Support at Home service',
    type: 'text',
    classNames: { column: 'sah-cutover-wrap-cell' },
  },
  {
    id: 'status',
    header: 'Status',
    caption: 'Whether this service type is already associated with the replacement service',
    type: 'text',
    style: { width: STATUS_WIDTH },
    deriveValue: (row: any) => (row.already_associated ? 'Already associated' : 'To be associated'),
  },
];

export default columns;
